module.exports = __webpack_public_path__ + "static/media/DSC_1501-HDR.399172fd.jpg";